









































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';
import { SfProductCard } from '@storefront-ui/vue';
import PafiProductCard from '~/components/PafiProductCard.vue';
import { useImage } from '~/composables';
import type { Product } from '~/modules/catalog/product/types';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import productGetters from '~/modules/catalog/product/getters/productGetters';

export default defineComponent({
  components: {
    CategoryProductPrice,
    SfProductCard,
    SkeletonLoader,
    PafiProductCard,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    skeletonRows: {
      type: Number,
      required: false,
      default: 3,
    },
    catName: {
      type: String,
      default: '',
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:add-to-cart'],
  setup(props) {
    const {
      imageSizes: { productCard: imageSize },
    } = useImage();
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);

    const getProductColors = function (product) {
      let type = productGetters.getTypeId(product);

      if (type != 'ConfigurableProduct') return [];

      if (!product.configurable_options) return [];

      const colorImageAttributesArr = [
        'color_acryl',
        'color_copic',
        'engraving_color',
        'raeder_herz_color',
        'smd_colorswatch_product_list',
        'use_smd_colorswatch',
      ];
      const colorAttributesArr = [
        'color',
        'colorswatch_color',
        'color_config_art',
        'color_config_chameleon',
        ...colorImageAttributesArr,
      ];

      let colors = [];
      for (let option of product.configurable_options) {
        if (colorAttributesArr.includes(option.attribute_code)) {
          for (let color of option.values) {
            colors.push({
              label: color.label,
              color: colorImageAttributesArr.includes(option.attribute_code)
                ? productGetters.getImageSwatchData(color.swatch_data)
                : productGetters.getSwatchData(color.swatch_data),
            });
          }
        }
      }

      return colors;
    };

    return {
      getProductColors,
      imageSize,
      productsWithCommonProductCardProps,
    };
  },
});
